import React, { memo } from 'react';
import LazyImage from '../../CustomLibraries/LazyImage';
import { MdOutlineArrowRightAlt } from '../../icons';
import './css/automatedCTA.scss';
import queryString from 'query-string';
import { useLocation } from 'react-router-dom';
import { content_cta_suscribe_speciality_v2_static_image } from '../../../common/assets.common';

const CtaSubscribeSpecialityV2 = ({ data, onClickCallback, isSubscribed, position }) => {
  const { pathname, search } = useLocation();
  const { id } = queryString.parse(search);
  return (
    <div className="subsServiceCTABox p-5 w-100 position-relative overflow-hidden shadow p-5 rounded-3">
      <div className="ctaCardBoxIn">
        <div className="d-flex flex-column align-items-center ctaCardTop">
          <div className="ctaCardIcon mb-5">
            <img
              src={content_cta_suscribe_speciality_v2_static_image}
              alt=""
              className="object-fit-cover w-100 h-100 float-start"
            />
          </div>
          <h4 className="fs-3 text-black fw-semibold text-center mb-3">
            Interested in <span className="text-secondary">{data?.speciality}</span> Content?
          </h4>
          <h6 className="fs-4 fw-medium text-dark mb-5 text-center">
            CLIRNET has a unique encyclopedia of real world medical content built through
            collaborative efforts of your fellow doctors
          </h6>
          <button
            className="w-100 btn fs-4 btn-primary fw-medium rounded-3 text-center ctaLink d-flex align-items-center justify-content-center gap-2"
            disabled={isSubscribed}
            onClick={() =>
              onClickCallback(
                data?.id,
                data?.cta_type_id,
                data?.entity_id,
                data?.entity_value,
                3,
                pathname,
                id
              )
            }
          >
            {isSubscribed ? 'Subscribed' : 'Subscribe Now'}{' '}
            <MdOutlineArrowRightAlt customClass={'fs-2'} />
          </button>
        </div>
      </div>
    </div>
  );
};

export default memo(CtaSubscribeSpecialityV2);
